import React, { FC } from "react";
import { Box, CircularProgress } from "@mui/material";

interface ILoadingProps {
  size?: number;
  sx?: object;
  centerAll?: boolean;
}

const Loading: FC<ILoadingProps> = ({ size = 36, sx, centerAll }) => {
  const centerAllStyle = centerAll ?
    { position: "absolute", marginTop: "200px", left: "50%", transform: `translate(-${size/2}px, -${size/2}px)` } :
    { };

  return (
    <Box
      sx={{
        textAlign: "center",
        ...centerAllStyle,
        ...sx,
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
};

export default Loading;
